/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CardSchemePriceOverride } from './CardSchemePriceOverride';
import {
    CardSchemePriceOverrideFromJSON,
    CardSchemePriceOverrideFromJSONTyped,
    CardSchemePriceOverrideToJSON,
    CardSchemePriceOverrideToJSONTyped,
} from './CardSchemePriceOverride';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';

/**
 * 
 * @export
 * @interface CreatePaymentFeeRequest
 */
export interface CreatePaymentFeeRequest {
    /**
     * 
     * @type {Currency}
     * @memberof CreatePaymentFeeRequest
     */
    currency: Currency;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentFeeRequest
     */
    fixedFeeAmount: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentFeeRequest
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof CreatePaymentFeeRequest
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentFeeRequest
     */
    variableFeePercentage: string;
    /**
     * 
     * @type {Date}
     * @memberof CreatePaymentFeeRequest
     */
    activeFrom?: Date | null;
    /**
     * 
     * @type {Array<CardSchemePriceOverride>}
     * @memberof CreatePaymentFeeRequest
     */
    cardSchemePriceOverrides?: Array<CardSchemePriceOverride> | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePaymentFeeRequest
     */
    locationId?: number | null;
}



/**
 * Check if a given object implements the CreatePaymentFeeRequest interface.
 */
export function instanceOfCreatePaymentFeeRequest(value: object): value is CreatePaymentFeeRequest {
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('fixedFeeAmount' in value) || value['fixedFeeAmount'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('variableFeePercentage' in value) || value['variableFeePercentage'] === undefined) return false;
    return true;
}

export function CreatePaymentFeeRequestFromJSON(json: any): CreatePaymentFeeRequest {
    return CreatePaymentFeeRequestFromJSONTyped(json, false);
}

export function CreatePaymentFeeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentFeeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': CurrencyFromJSON(json['currency']),
        'fixedFeeAmount': json['fixedFeeAmount'],
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'variableFeePercentage': json['variableFeePercentage'],
        'activeFrom': json['activeFrom'] === undefined ? undefined : json['activeFrom'] === null ? null : (new Date(json['activeFrom'])),
        'cardSchemePriceOverrides': json['cardSchemePriceOverrides'] === undefined ? undefined : json['cardSchemePriceOverrides'] === null ? null : ((json['cardSchemePriceOverrides'] as Array<any>).map(CardSchemePriceOverrideFromJSON)),
        'locationId': json['locationId'] === undefined ? undefined : json['locationId'] === null ? null : json['locationId'],
    };
}

export function CreatePaymentFeeRequestToJSON(json: any): CreatePaymentFeeRequest {
    return CreatePaymentFeeRequestToJSONTyped(json, false);
}

export function CreatePaymentFeeRequestToJSONTyped(value?: CreatePaymentFeeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': CurrencyToJSON(value['currency']),
        'fixedFeeAmount': value['fixedFeeAmount'],
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'variableFeePercentage': value['variableFeePercentage'],
        'activeFrom': value['activeFrom'] == null ? value['activeFrom'] : value['activeFrom'].toISOString(),
        'cardSchemePriceOverrides': value['cardSchemePriceOverrides'] == null ? undefined : ((value['cardSchemePriceOverrides'] as Array<any>).map(CardSchemePriceOverrideToJSON)),
        'locationId': value['locationId'],
    };
}

